/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { EventsService } from '@app/events/events/events.service';
import { EventsFormService } from '@app/events/events/events-form.service';
import { Events } from '@app/events/events/events.model';
import { ActivatedRoute, Router } from '@angular/router';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { EventsSeoFormService } from '@app/events/events/events-seo-form.service';
import { environment } from '@env/environment';
import { DataSet } from '@app/shared/kendo/data-set';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';
import { LaravelModelsEnum } from '@app/shared/models/model.model';

const log = new Logger('EventsListComponent');

@Component({
  selector: 'app-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.scss'],
})
export class EventsListComponent extends KendoGridComponent implements OnInit {
  eventsResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  eventGroupId: number;
  AuthenticationService = AuthenticationService;

  UserRoleType = UserRoleType;
  LaravelModels = LaravelModelsEnum;

  constructor(
    private eventsService: EventsService,
    private eventsFormService: EventsFormService,
    private route: ActivatedRoute,
    protected kendoGridService: KendoGridService,
    private eventSeoFormService: EventsSeoFormService,
    private router: Router,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    // Проверява дали има подаден параметър event_group_id в адреса и зарежда данните с филтър
    this.route.queryParamMap.subscribe((params) => {
      this.state = null;

      this.state = CustomKendoFilter.getStateFromStorage('EventsListComponent');

      if (params.get('event_group_id')) {
        this.eventGroupId = Number(params.get('event_group_id'));
        this.state = new DataSet().addFilter('event_group_id', Number(params.get('event_group_id')));
      }

      if (params.get('dataSet')) {
        this.state = DataSet.decodeFromJson(params.get('dataSet'));
      }

      this.loadData(this.state);
    });
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery
      .setDataSetFilters(state)
      .addIncludes(
        'industry',
        'venue.city.country',
        'event_group',
        'type',
        'city.country',
        'hotel_bookings_count',
        'adv_hotel_bookings_by_hotel_count',
        'adv_hotel_bookings_rooms_count',
        'adv_hotel_bookings_rooms',
        'priority',
        'tags',
        'enquiries_count'
      );

    this.eventsService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.eventsResponse = response;
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('EventsListComponent', this.state);
  }

  add() {
    this.eventsFormService.open().then(
      (response) => {
        this.loadData(this.state);
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  edit(event: Events) {
    this.eventsFormService.open(event).then(
      () => {
        this.loadData(this.state);
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  delete(event: Events) {
    this.eventsService.destroy(event.id).subscribe(
      () => {
        this.loadData(this.state);
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *  Отваря SEO формата
   * @param event Events
   */
  editSeo(event: Events): void {
    this.eventSeoFormService.open(event);
  }

  clearFilters() {
    this.router.navigate(['/events']);

    this.apiQuery = new ApiQuery();
    this.loadData();
  }

  pushToStorage(dataItem: Events) {
    CustomKendoFilter.pushObjectInStorage(dataItem, 'events');
  }
}
